import React, { useCallback, useState, useEffect } from "react";
import {
  DropZone,
  Page,
  FormLayout,
  TextField,
  Card,
  Checkbox,
  Stack,
  ButtonGroup,
  Button,
  Select,
} from "@shopify/polaris";
import axios from "../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import Instruction from "./Instruction";
import { ColorsMajor } from "@shopify/polaris-icons";
import { accessEditSections } from "../Helpers";

const Navigation = (props) => {
  let object = JSON.parse(props.object);
  const { id } = useParams();

  const handleChange = (newChecked) => {
    setItem({ ...item, active: newChecked });
  };
  const handleSelectChangeMenu = (newValue) => {
    setItem({ ...item, menu: newValue });
  };
  const [item, setItem] = useState({
    menu: "",
    active: "",
  });
  useEffect(() => {
    object = JSON.parse(props.object);
    setItem({
      menu:
        object?.details?.navigation_pivot_list_id !== null
          ? String(object?.details?.navigation_pivot_list_id)
          : "",
      active: object?.details?.is_active ? true : false,
    });
  }, [props.object]);
  return (
    <FormLayout>
      <FormLayout.Group>
        <Select
          label="Navigation"
          options={props.menusArray}
          onChange={handleSelectChangeMenu}
          value={item.menu}
          placeholder="Please select"
        />
      </FormLayout.Group>
      <Checkbox
        label="Is Active"
        checked={item.active}
        onChange={handleChange}
      />
      <FormLayout.Group>
        <div style={{ float: "right" }}>
          <Button
            primary
            onClick={handleSave}
            loading={props.isSaving}
            disabled={!accessEditSections()}
          >
            Save
          </Button>
        </div>
      </FormLayout.Group>
    </FormLayout>
  );
  function handleSave() {
    props.handleSavingState();
    const form_data = new FormData();
    form_data.append("navigation_pivot_list_id", item.menu);
    form_data.append("is_active", item.active ? 1 : 0);
    form_data.append("_method", "PATCH");
    props.selectedChannels && props.selectedChannels.length
      ? props.selectedChannels.forEach((selected, index) =>
          form_data.append(`channels[${index}]`, selected)
        )
      : form_data.append(`channels`, []);
    axios
      .post(`/pages/${id}/sections/${props.sectionId}`, form_data)
      .then((res) => {
        props.handleSaveAndRefresh();
      })
      .catch((err) => console.log(""));
  }
};
export default Navigation;
